const highlightModule = (() => {
  const originalContentMap = {};
  let resizeTimeout;
  let resizeListener = null;

  const keywordMap = {
    'en-US': 'Minutes',
    'en-GB': 'Minutes',
    'es-419': 'minutos',
    'it-IT': 'minuti',
    'fr-FR': 'minutes',
    'pt-BR': 'minutos',
    'de-DE': 'Minuten',
    'ja-JP': '分',
    'zh-CN': '分钟',
  };

const freeMap = {
  'en-US': '3 Free',
  'en-GB': '3 Free',
  'es-419': '3 gratis',
  'it-IT': '3 gratuiti',
  'fr-FR': '3 gratuits',
  'pt-BR': '3 gratuitos',
  'de-DE': '3 kostenlose',
  'ja-JP': '3件無料',
  'zh-CN': '3份免费',
};


  const allInJustMinutesMap = {
    'en-US': 'all in just minutes',
    'de-DE': 'in wenigen Minuten',
    'en-GB': 'all in just minutes',
    'fr-FR': 'en quelques minutes',
    'es-419': 'en solo unos minutos',
    'ja-JP': 'わずか数分で',
    'it-IT': 'in pochi minuti',
    'pt-BR': 'em poucos minutos',
    'zh-CN': '在几分钟内',
  };

  const over30StylesMap = {
    'en-US': 'over 30 styles',
    'de-DE': 'über 30 Designs',
    'en-GB': 'over 30 styles',
    'fr-FR': 'plus de 30 styles',
    'es-419': 'más de 30 estilos',
    'ja-JP': '30種類以上のスタイル',
    'it-IT': 'oltre 30 stili',
    'pt-BR': 'mais de 30 estilos',
    'zh-CN': '30多种风格',
  };

    const certaintyKeywordMap = {
    'en-US': '100% certainty',
    'en-GB': '100% certainty',
    'es-419': 'mayor seguridad',
    'it-IT': '100% tranquillo',
    'fr-FR': 'certitude à 100%',
    'pt-BR': '100% de certeza',
    'de-DE': '100% Sicherheit',
    'ja-JP': '100％の確実性',
    'zh-CN': '100% 确保',
  };

  const pricingPlanMap = {
    'en-US': 'Select a Plan',
    'en-GB': 'Plan',
    'es-419': 'Plan',
    'it-IT': 'Piano',
    'fr-FR': 'Forfait',
    'pt-BR': 'Plano',
    'de-DE': 'Tarif',
    'ja-JP': 'プラン',
    'zh-CN': '方案',
  };


  const elementIds = [
    { id: 'resumeHeadline', keywordMap, options: { bottom: '-4px', height: '.2em', strong: false } },
    { id: 'freeHeadline', keywordMap: freeMap, options: { bottom: '0px', height: '.3em', strong: true } },
    { id: 'resumeCertaintyHeadline', keywordMap: certaintyKeywordMap, options: { bottom: '-1px', height: '.4em', strong: true } },
    { id: 'alreadyHaveResumeOr', keywordMap: allInJustMinutesMap, options: { bottom: '-1px', height: '.4em', strong: true } },
    { id: 'choosefrom30Styles', keywordMap: over30StylesMap, options: { bottom: '-1px', height: '.4em', strong: true } },
    { id: 'pricingplan', keywordMap: pricingPlanMap, options: { bottom: '-1px', height: '.2em', strong: true } },
  ];

  const applyHighlights = () => {
    const locale = getLanguage?.() || 'en-US';
    elementIds.forEach(({ id, keywordMap, options }) => {
      highlight(id, keywordMap[locale], options);
    });
  };

  const runAfterFullLayout = (fn, delay = 50) => {
    const doHighlight = () => {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setTimeout(fn, delay);
            });
          });
        });
      } else {
        // If FontFaceSet API is not supported, fall back to just animation frame and timeout
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(fn, delay);
          });
        });
      }
    };

    if (document.readyState !== 'complete') {
      window.addEventListener('load', doHighlight, { once: true });
    } else {
      doHighlight();
    }
  };

  // Usage




  const init = () => {
    // Preserve original HTML before highlighting
    elementIds.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el && !(id in originalContentMap)) {
        originalContentMap[id] = el.innerHTML;
      }
    });

    runAfterFullLayout(applyHighlights, 50);

    // Create and store resize listener
    resizeListener = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        restoreOriginalHTML();
        applyHighlights();
      }, 200);
    };

    window.addEventListener('resize', resizeListener);
  };

  const highlight = (elementId, keyword, { bottom, height, strong }) => {
    const el = document.getElementById(elementId);
    if (!el || !el.textContent?.trim()) return;

    const range = document.createRange();
    const textNode = el.firstChild;
    const startIndex = textNode.textContent.indexOf(keyword);
    if (startIndex === -1) return;

    if (strong) {
      const span = document.createElement('span');
      span.style.fontWeight = 'bold';
      range.setStart(textNode, startIndex);
      range.setEnd(textNode, startIndex + keyword.length);
      range.surroundContents(span);
    } else {
      range.setStart(textNode, startIndex);
      range.setEnd(textNode, startIndex + keyword.length);
    }

    const rects = range.getClientRects();
    if (rects.length === 0) return;

    el.querySelectorAll('.brushstroke').forEach(e => e.remove());
    el.style.position = 'relative';

    Array.from(rects).forEach(rect => {
      const brush = document.createElement('span');
      brush.className = 'brushstroke';
      brush.style.position = 'absolute';
      brush.style.left = `${rect.left - el.getBoundingClientRect().left}px`;
      brush.style.top = `${rect.bottom - el.getBoundingClientRect().top + parseFloat(bottom)}px`;
      brush.style.width = `${rect.width}px`;
      brush.style.height = height;
      el.appendChild(brush);
    });
  };



  const restoreOriginalHTML = () => {
    Object.entries(originalContentMap).forEach(([id, html]) => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = html;
    });
  };

  const unload = () => {
    if (resizeListener) {
      window.removeEventListener('resize', resizeListener);
      resizeListener = null;
    }

    restoreOriginalHTML();

    Object.keys(originalContentMap).forEach(id => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = '';
    });
  };

  return { init, unload };
})();

export default highlightModule;
